import React from 'react'
import StyledFormStep from '../JoinClubHeader/StyledFormStep.styles'
import StyledPayFailWelcome from './PayFailWelcome.styles'



const PayFailWelcome = () => {
  return (
    <StyledPayFailWelcome>

<div className="hero-section">

<h3>Oh, no! The Transaction has Failed.</h3>
<p>Don't worry try again, or contact member and guest services conceirge at <a href="tel:(708) 215-5674">(708) 215-5674</a>.</p>
<br />
<div className="hero-welcome-footer">
<p>Questions about your order?</p>
<a class="contact-link" href="/">Contact Us</a>
<br />

<StyledFormStep>
    <button className="btn btn-primary">Back to cooper's hawk</button>
</StyledFormStep>

</div>


    </div>
   {/* <video id="videoBkg" poster="https://www.sicontis.com/codepen/cpc-spacing/ski.png" autoplay muted loop >
      <source src="https://www.sicontis.com/codepen/cpc-spacing/skiing.mp4" type="video/mp4" />
    </video> */}
    <img id="imgBkg" src="https://dl3.pushbulletusercontent.com/Srzd6HrJliIVsS5v58m1dFDBEXeoVn0H/Spilled%20Wine.png" alt="" />




    </StyledPayFailWelcome>
  )
}

export default PayFailWelcome